import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { Button, ScrollToTop } from '@/components';
import { useBookingStore } from '@/store';

const AlipayPayment: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { balance } = useBookingStore();

  const handleConfirmPayment = () => {
    // Process Alipay payment confirmation
    navigate('/booking/thank-you');
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <ScrollToTop />
      <div className="mx-auto max-w-2xl px-4">
        <h2 className="mb-6 text-2xl font-bold">{t('alipay.title')}</h2>

        <div className="space-y-6">
          {/* QR Code Section */}
          <div className="rounded-lg border bg-white p-8 text-center">
            <h3 className="mb-4 text-lg font-semibold">{t('alipay.scanQR')}</h3>

            {/* QR Code Placeholder */}
            <div className="mx-auto mb-4 flex h-64 w-64 items-center justify-center rounded-lg border-2 border-dashed border-gray-300 bg-gray-100">
              <div className="text-center">
                <div className="mb-2 text-4xl">💰</div>
                <p className="text-sm text-gray-500">{t('alipay.qrCode')}</p>
                <p className="text-xs text-gray-400">
                  {t('alipay.scanWithApp')}
                </p>
              </div>
            </div>

            <p className="text-sm text-gray-600">{t('alipay.openApp')}</p>
          </div>

          {/* Instructions */}
          <div className="rounded-lg bg-blue-50 p-4">
            <h4 className="mb-2 font-semibold text-blue-800">
              {t('alipay.instructions')}
            </h4>
            <ol className="list-inside list-decimal space-y-1 text-sm text-blue-700">
              <li>{t('alipay.step1')}</li>
              <li>{t('alipay.step2')}</li>
              <li>{t('alipay.step3')}</li>
              <li>{t('alipay.step4')}</li>
              <li>{t('alipay.step5')}</li>
            </ol>
          </div>

          {/* Payment Amount */}
          <div className="rounded-lg bg-green-50 p-4 text-center">
            <p className="text-sm text-gray-600">{t('alipay.amountToPay')}</p>
            <p className="text-2xl font-bold text-green-600">
              {t('common.currency')}
              {balance.total.toLocaleString()}
            </p>
          </div>

          {/* Navigation Buttons */}
          <div className="flex justify-between pt-6">
            <Button
              variant="secondary"
              onClick={() => navigate('/booking/summary')}
            >
              {t('common.back')}
            </Button>
            <Button onClick={handleConfirmPayment}>
              {t('alipay.completedPayment')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlipayPayment;
